// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.input-select-region[data-v-704d25de] .multiselect.office_new,.input-select-region[data-v-704d25de] .multiselect.office_new.multiselect--active.searchable{width:100%!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
